export default __webpack_public_path__ + "static/media/afts-image.29aaf8bc.png";